import computeTagName from "../../../../../utils/computeTagName";
import computeClassName from "../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE : 'font-normal',
  TAG_DEFAULT: 'span'
});
const propsDefaults = Object.freeze({
  savedCount: 0,
  tag: constants.TAG_DEFAULT
});

export default function PartnerSavedTotalCount({
  savedCount = propsDefaults.savedCount,
  tag = propsDefaults.tag,
  className = ''
}) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return <ComputedTagName className={computedClassName}>{savedCount}</ComputedTagName>
}
